import React, { ImgHTMLAttributes } from 'react';

type Props = ImgHTMLAttributes<SVGElement>;

const TransferFunds: React.FC<Props> = ({ className }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path
      d='M3.35601 7.38387L3.34904 10.7592L12.0247 2.0835L12.9166 2.97538L4.24062 11.6514L7.61623 11.6441L7.61894 12.9054L2.08325 12.9173L2.09469 7.38126L3.35601 7.38387Z'
      fill='currentColor'
    />
    <path
      d='M17.0605 13.0334L17.0675 9.6581L8.39181 18.3338L7.49992 17.4419L16.1759 8.76591L12.8003 8.77318L12.7976 7.51186L18.3333 7.49994L18.3218 13.036L17.0605 13.0334Z'
      fill='currentColor'
    />
  </svg>
);

export { TransferFunds };
